import { render, staticRenderFns } from "./UnassignedBookings.vue?vue&type=template&id=5964fac0&scoped=true&"
import script from "./UnassignedBookings.vue?vue&type=script&lang=ts&"
export * from "./UnassignedBookings.vue?vue&type=script&lang=ts&"
import style0 from "./UnassignedBookings.vue?vue&type=style&index=0&id=5964fac0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5964fac0",
  null
  
)

export default component.exports